import { type OrganisationUsage } from "shared/services/api/OrganisationsService";

export function buildDefaultOrganisationUsage(): OrganisationUsage {
  return {
    active_users_count: 0,
    ai_visibility_credits_consumed: null,
    ai_visibility_credits_period_end: "",
    ai_visibility_credits_period_start: "",
    ai_visibility_credits_subscription_active: null,
    ai_visibility_credits_synced_at: null,
    ai_visibility_credits_total: null,
    ai_visibility_max_prompts: null,
    ai_visibility_max_sources: null,
    max_dashboards_with_ai_visibility: null,
    max_instant_insights_reports_with_monitoring: null,
    max_social_streams_count: 0,
    max_streams_count: 0,
    max_teams_count: 0,
    max_users_count: 0,
    social_streams_count: 0,
    streams_count: 0,
    teams: [],
    usage_by_month: {},
  };
}
